import { motion } from "framer-motion";
import { Clock, ArrowUpRight } from "lucide-react";
import { blogs } from "../lib/data";

export default function BlogsSection() {
  return (
    <section id="blog" className="relative py-28 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="section-label">Insights</span>
            <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
              Blogs & <span className="gradient-text">market insights</span>
            </h2>
          </div>
          <a href="#" className="btn-ghost text-sm" data-testid="blog-all">View all articles</a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogs.map((b, i) => (
            <motion.article
              key={b.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              className="glass rounded-2xl overflow-hidden card-glow transition-all group"
              data-testid={`blog-card-${b.id}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img src={b.img} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F24] to-transparent" />
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-blue-600/90 backdrop-blur text-[10px] font-bold uppercase tracking-widest">
                  {b.category}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-slate-500 mb-3">
                  <span>{b.date}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{b.readTime}</span>
                </div>
                <h3 className="text-lg font-bold leading-snug group-hover:text-blue-300 transition-colors">{b.title}</h3>
                <a href="#" className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-400">
                  Read article <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
